export default __webpack_public_path__ + "static/media/browser-firefox.dc40f2c2.svg";